import { NoDataImage, SearchResultsItemWrapper } from './search-results.styles';

export const EmptySearchResultsItem = () => {
  return (
    <SearchResultsItemWrapper sx={{ flexDirection: 'column' }}>
      <NoDataImage />
      There are no records matching your search terms.
    </SearchResultsItemWrapper>
  );
};
